var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"border-b border-gray-300 bg-white flex-none flex px-32",style:({ height: (_vm.height + "px") })})}
var staticRenderFns = []

export { render, staticRenderFns }